import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { RxDashboard } from "react-icons/rx";
import { IoDocumentsOutline } from "react-icons/io5";
import { DiGoogleAnalytics } from "react-icons/di";
import { BsPeopleFill } from "react-icons/bs";
import { BsFillPersonPlusFill } from "react-icons/bs";
import { FaPeopleGroup } from "react-icons/fa6";
import { FaIdBadge } from "react-icons/fa";
import { MdManageSearch } from "react-icons/md";
import { FaReceipt } from "react-icons/fa";
import { MdPayments } from "react-icons/md";
import { CgProfile } from "react-icons/cg";
import { IoMdSettings } from "react-icons/io";
import { IoLogOutSharp } from "react-icons/io5";
import Cookies from "js-cookie";
import logo from "../images/litax_logo.png";
import { useYearContext } from "./YearContext";

const Adminsidebar = ({ openSidebarToggle, openSidebar }) => {
  const navigate = useNavigate();
  const { clearYearFromLocalStorage } = useYearContext();

  const handleLogout = () => {
    Cookies.remove("token");
    localStorage.removeItem("role");
    clearYearFromLocalStorage();
    navigate("/login");
  };
  return (
    <aside
      id="invoice-sidebar"
      className={openSidebarToggle ? "sidebar-responsive" : ""}
    >
      <div className="sidebar-title">
        <div className="sidebar-brand d-flex gap-2  align-items-center">
          <img src={logo} className="w-25 h-25" />
          <h5>Litax</h5>
        </div>
        <span className="icon close_icon" onClick={openSidebar}>
          X
        </span>
      </div>

      <ul className="sidebar-list">
        <li className="sidebar-list-item">
          <NavLink
            to="/admin"
            className={({ isActive }) => (isActive ? "active-link" : "")}
          >
            <RxDashboard size={18} className="me-3" />
            Dashboard
          </NavLink>
        </li>
        <li className="sidebar-list-item">
          <NavLink
            to="/adminanalytics"
            className={({ isActive }) => (isActive ? "active-link" : "")}
          >
            <DiGoogleAnalytics size={18} className="me-3" />
            Analytics
          </NavLink>
        </li>
        <li className="sidebar-list-item">
          <NavLink
            to="/clients"
            className={({ isActive }) => (isActive ? "active-link" : "")}
          >
            <BsPeopleFill size={18} className="me-3" />
            Clients
          </NavLink>
        </li>
        {/* <li className="sidebar-list-item">
          <NavLink
            to="/leads"
            className={({ isActive }) => (isActive ? "active-link" : "")}
          >
            <BsFillPersonPlusFill size={18} className="me-3" />
            Leads
          </NavLink>
        </li> */}

        <li className="sidebar-list-item">
          <NavLink
            to="/documentstimeline"
            className={({ isActive }) => (isActive ? "active-link" : "")}
          >
            <IoDocumentsOutline size={18} className="me-3" />
            Documents
          </NavLink>
        </li>
        {/* <li className="sidebar-list-item">
          <NavLink
            to="/employeinformation"
            className={({ isActive }) => (isActive ? "active-link" : "")}
          >
            <FaPeopleGroup size={18} className="me-3" />
            Employee's Info
          </NavLink>
        </li> */}
        {/* <li className="sidebar-list-item">
          <NavLink
            to="/employeestatus"
            className={({ isActive }) => (isActive ? "active-link" : "")}
          >
            <FaIdBadge size={18} className="me-3" />
            Employee's Stats
          </NavLink>
        </li> */}
        <li className="sidebar-list-item">
          <NavLink
            to="/searchclient"
            className={({ isActive }) => (isActive ? "active-link" : "")}
          >
            <MdManageSearch size={20} className="me-3" />
            Search Client
          </NavLink>
        </li>
        <li className="sidebar-list-item">
          <NavLink
            to="/invoice"
            className={({ isActive }) => (isActive ? "active-link" : "")}
          >
            <FaReceipt size={18} className="me-3" />
            Invoice
          </NavLink>
        </li>
        <li className="sidebar-list-item">
          <NavLink
            to="/payments"
            className={({ isActive }) => (isActive ? "active-link" : "")}
          >
            <MdPayments size={18} className="me-3" />
            Payments
          </NavLink>
        </li>
        <li className="sidebar-list-item">
          <NavLink
            to="/adminprofile"
            className={({ isActive }) => (isActive ? "active-link" : "")}
          >
            <CgProfile size={18} className="me-3" />
            My Profile
          </NavLink>
        </li>
        <li className="sidebar-list-item">
          <NavLink
            to="/adminsettings"
            className={({ isActive }) => (isActive ? "active-link" : "")}
          >
            <IoMdSettings size={18} className="me-3" />
            Settings
          </NavLink>
        </li>

        <div className="sidebar-list-item" onClick={handleLogout}>
          <IoLogOutSharp size={18} className="me-3" />
          Logout
        </div>
      </ul>
    </aside>
  );
};

export default Adminsidebar;
